import type { useForm } from "hooks";
import type { BootstrapableForm } from "types";
import type {
    WithRequestedChangeFileds,
    WithFieldsStatuses,
    WithFieldsComments
} from "features/onboarding/types";
import type { OnboardingFormProps } from "ui/forms/Onboarding/shared";
import type { Identity } from "./entities";

export const enum FormField {
    FullName = 'fullName',
    DateOfBirth = 'dateOfBirth',
    ResidentialAddress = 'residentialAddress',
    Nationality = 'nationality',
    IdentityFileKey = 'identityFileKey',
    AddressFileKey = 'addressFileKey',
    LegalForm = 'legalForm'
};

export type IdentityVerification =
    & WithFieldsStatuses
    & WithFieldsComments
    & WithRequestedChangeFileds
    & {
        readonly uboIdentities: Array<Identity>;
    };

export type OnboardingIdentityVerificationForm =
    & Omit<
        BootstrapableForm<IdentityVerification, {}>,
        | 'initialValues'
    >
    & {
        readonly initialValues: IdentityVerification;
    };

export type OnboardingIdentityVerificationProps =
    & OnboardingFormProps
    & OnboardingIdentityVerificationForm
    & ReturnType<typeof useForm<IdentityVerification>>;
